import {IStore} from "modules/types";

export const getSortTableParams = (state: IStore) => state.riders_table;
